<template>
  <div
    class="login_page"
    :style="{
      background:
        'url(' +
        $utils.formatImgUrl('loginBanner.png') +
        ') no-repeat center center',
      backgroundSize: '100% 100%',
    }"
  >
    <!-- 外层容器 -->
    <div class="login_container" id="bigBox">
      <div class="bannerTitle">
        <h1>润信数字智能科技</h1>
        <p>AI赋能千行百业</p>
      </div>
      <!-- 登录盒子 -->
      <div class="login_box">
        <!-- 标题 -->
        <div class="login_title">用户{{ pageText }}</div>

        <!-- 表单区域 -->
        <div class="form_wrap">
          <!-- 账号 -->
          <div class="form_item">
            <input
              type="text"
              placeholder="请输入手机号"
              v-model="form.phone"
            />
            <span class="error_msg" v-show="phoneShow">{{ phoneErrText }}</span>
          </div>

          <div class="form_item" v-show="imgCodeFormShow">
            <input
              type="text"
              placeholder="请输入图形验证码"
              v-model="imgCode"
            />
            <div class="img_code_box" @click="getImgCodeFun">
              <img :src="imgCodeUrl" alt="" />
            </div>
            <span class="error_msg" v-show="imgCodeShow">{{
              imgCodeText
            }}</span>
          </div>

          <div class="form_item">
            <input
              type="text"
              placeholder="请输入验证码"
              v-model="form.code"
              style="border-radius: 6px 0 0 6px"
            />
            <el-button
              class="login_btn theme_color"
              :disabled="codeBtnFlag"
              @click="getCode"
              style="border-radius: 0 6px 6px 0"
            >
              {{ getCodeText }}
            </el-button>
            <span class="error_msg" v-show="codeShow">{{ codeErrText }}</span>
          </div>
        </div>

        <el-button class="login_btn theme_color" @click="handleLogin">
          {{ pageText }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getImgCodeApi, getCodeApi, loginApi } from "@/apis/index.js";
export default {
  name: "Login",
  data() {
    return {
      form: {
        phone: "",
        code: "",
      },
      imgCode: "", // 图形验证码
      imgCodeFormShow: false, // 图形验证码表单是否显示
      imgCodeText: "请输入图形验证码!", // 图形验证码提示
      imgCodeUrl: "", // 图形验证码图片
      imgCodeShow: false, // 图形验证码错误提示
      pageText: "登录",
      phoneShow: false,
      phoneErrText: "手机号不能为空！",
      codeShow: false,
      codeErrText: "验证码不能为空！",
      getCodeText: "获取验证码",
      codeBtnFlag: false, // 验证码按钮是否禁用
      time: 60, // 倒计时秒数
      timer: null, // 定时器
    };
  },
  created() {
    if (this.$route.query.pageText) {
      this.pageText = this.$route.query.pageText;
    }
  },
  methods: {
    // 获取手机验证码
    async getCode() {
      if (this.imgCodeFormShow) {
        if (!this.imgCode) {
          this.imgCodeShow = true;
          return;
        } else {
          this.imgCodeShow = false;
          this.getCodeFun();
        }
      } else {
        // 校验手机号
        if (this.$utils.checkPhone(this.form.phone).valid) {
          this.phoneShow = false;
          this.imgCodeFormShow = true;
          this.getImgCodeFun();
        } else {
          this.phoneShow = true;
          this.phoneErrText = this.$utils.checkPhone(this.form.phone).msg;
          return;
        }
      }
    },

    // 倒计时逻辑
    startTimer() {
      this.timer = setInterval(() => {
        this.time--;
        this.getCodeText = this.time + "秒后重新获取";
        if (this.time <= 0) {
          this.getCodeText = "重新获取";
          clearInterval(this.timer);
          this.codeBtnFlag = false;
          this.time = 60;
        }
      }, 1000);
    },
    async handleLogin() {
      if (!this.form.code) {
        this.codeShow = true;
        this.codeErrText = "请输入验证码";
        return;
      } else {
        let data = await loginApi({
          mobile: this.form.phone,
          captcha: this.form.code,
        });
        if (data.code == 200) {
          localStorage.setItem(
            "userInfo",
            JSON.stringify(data.result.userInfo),
          );
          localStorage.setItem("token", data.result.token);

          this.$utils.showMsg("success", data.message, 1000, () => {
            this.$router.push("/");
          });
        } else {
          this.$utils.showMsg("error", data.message);
        }
      }
    },
    async getImgCodeFun() {
      let data = await getImgCodeApi({ phone: this.form.phone });
      if (data.code == 200) {
        this.imgCodeUrl = data.result;
        this.imgCodeText = "请输入图形验证码";
        this.imgCode = "";
      } else {
        this.imgCodeText = data.message;
        this.$utils.showMsg("error", data.message, 3000);
      }
    },
    async getCodeFun() {
      let data = await getCodeApi({
        mobile: this.form.phone,
        captcha: this.imgCode,
      });
      if (data.code == 200) {
        this.$utils.showMsg("success", data.message, 2000, () => {
          this.codeBtnFlag = true;
          this.imgCodeShow = false;
          this.startTimer();
        });
      } else {
        this.$utils.showMsg("error", data.message, 3000);
        this.imgCodeText = data.message;
        this.imgCodeShow = true;
        this.getImgCodeFun();
      }
    },
  },
};
</script>

<style scoped lang="less">
.login_page {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

// 登录容器
.login_container {
  display: flex;
  justify-content: flex-end;

  .bannerTitle {
    margin-top: 0;
    display: none;

    > p {
      margin-top: 60px;
    }
    > h1,
    > p {
      color: #fff;
      text-shadow: 0 1px 0 #ccc, 0 2px 0 #c9c9c9, 0 3px 0 #bbb, 0 4px 0 #b9b9b9,
        0 5px 0 #aaa, 0 6px 1px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1),
        2px 2px 3px rgba(0, 0, 0, 0.3), 3px 3px 10px rgba(0, 0, 0, 0.2);
    }
  }
}

// 登录盒子
.login_box {
  width: 100%;
  padding: 2.5rem 1.875rem;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(4px);
}

// 标题
.login_title {
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}

// 表单区域
.form_wrap {
  margin-bottom: 20px;
}

// 表单项
.form_item {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  position: relative;

  .error_msg {
    color: red;
    font-size: 0.75rem;
    position: absolute;
    top: 40px;
    left: -20px;
  }
  span {
    width: 140px;
    height: 42px;
    font-size: 0.875rem;
    color: #fff;
    cursor: pointer;
    line-height: 42px;
    border-radius: 0 6px 6px 0;
  }

  input {
    flex: 1;
    height: 42px;
    padding: 0 0.75rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    outline: none;
    font-size: 0.875rem;

    &:focus {
      border-color: #40a9ff;
    }
  }

  .img_code_box {
    display: flex;
    align-items: center;

    img {
      width: 120px;
      height: 50px;
      margin-left: 20px;
    }
  }
}

// 登录按钮
.login_btn {
  width: 100%;
  height: 42px;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
}
</style>
